<script setup>
import { computed } from 'vue';

const props = defineProps({
  prize: {
    type: Number,
    default: 0,
  },
  height: {
    type: Number,
    default: 40,
  },
  width: {
    type: Number,
    default: 40,
  },
});
const hackathonWinnerBadge = computed(() => `/docs/images/hackathon-badges/hackathon-${props.prize}.png`);
const title = computed(() => `Hackathon ${props.prize} badge`);
</script>

<template>
  <img
    :src="hackathonWinnerBadge"
    :height="height"
    :width="width"
    :alt="title"
    :title="title"
  >
</template>
